import React from "react";
import { Col, Modal, Row } from "react-bootstrap";
import ReturnFareSummary from "./ReturnFareSummary";
import OneWayFareSummary from "./OneWayFareSummary";

export default function FareSummary({
  fareShow,
  setFareShow,
  review,
  getTotalTax,
  getBaseFare,
  flightCommTypeOnWard,
  totalCarrierServiceChargesOnWard,
  flightCommTypeReturn,
  totalCarrierServiceChargesReturn,
  values,
  calculateSSRAmount,
}) {
  return (
    <div>
      <Modal
        size="lg"
        show={fareShow}
        onHide={() => setFareShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Fare Summary
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {review?.searchQuery.searchType == "RETURN" ? (
            <ReturnFareSummary
              values={values}
              review={review}
              getTotalTax={getTotalTax}
              getBaseFare={getBaseFare}
              calculateSSRAmount={calculateSSRAmount}
            />
          ) : (
            <OneWayFareSummary
              values={values}
              review={review}
              calculateSSRAmount={calculateSSRAmount}
            />
          )}
        </Modal.Body>
      </Modal>{" "}
    </div>
  );
}
